/*export interface Quality {
  title: string,
  letter: string,
}*/

const AUTO = 'auto';
const SOURCE = 'source';
const HIGH = 'high';
const MEDIUM = 'medium';
const LOW = 'low';

/*const SOURCE: Quality = {
  id: 'source',
  title: 'Исходное',
  letter: 'И',
};

const HIGH: Quality = {
  id: 'high',
  title: 'Высокое',
  letter: 'В',
};

const MEDIUM: Quality = {
  id: 'medium',
  title: 'Среднее',
  letter: 'С',
};

const LOW: Quality = {
  id: 'low',
  title: 'Мобильное',
  letter: 'М',
};*/

export const Qualities = {
  AUTO,
  SOURCE,
  HIGH,
  MEDIUM,
  LOW
};


export type Quality = string;

export const SingleBitrate: Quality[] = [SOURCE];
export const MultipleBitrates: Quality[] = [SOURCE, HIGH, MEDIUM, LOW];
export const MultipleBitratesWithAuto: Quality[] = [AUTO, SOURCE, HIGH, MEDIUM, LOW];

